import { InteractionType } from "@azure/msal-browser";
import { useMsal, useMsalAuthentication } from "@azure/msal-react";
import { useEffect } from "react";

export const useMicrosoftAuth = (scopes: string[]) => {
  const { login, result, acquireToken } = useMsalAuthentication(InteractionType.Silent, {
    scopes,
  });

  const { accounts } = useMsal();

  useEffect(() => {
    if (!result?.idToken && accounts?.length > 0) {
      (async () => {
        await acquireToken(InteractionType.Silent, { scopes, account: accounts[0] });
      })();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [result?.idToken, accounts]);

  return { login, result, accounts };
};
